module.exports = __webpack_public_path__ + "img/not-found.2e82f522.png";